import { Button } from './Button';
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { namespaces } from "../i18n.costants";

type QuoteButtonProps = {
  handleClick?: () => void;
  text?: string;
  [rest: string]: any;
};
export function QuoteRequestButton({ handleClick, text, ...rest }: QuoteButtonProps) {
  const { t } = useTranslation(namespaces.common);

  return (
    <ButtonContainer>
      <Button
        text={text ?? t("Richiedi un preventivo adesso")}
        textColor='white'
        backgroundColor='var(--color-blue-gradient)'
        callToAction={true}
        handleClick={handleClick}
        style={{ width: "100%", display: "block" }}
        {...rest}
      />
    </ButtonContainer>
  )
}


const ButtonContainer = styled.div`
  margin: auto; 
  max-width: max-content;
`;